(function(){
  'use strict';
  if(window.__g314ContactPreferences){window.__g314ContactPreferences.mount();return;}
  var VERSION='g314-contact-preferences-2026-10-19-v2',BASE='/apps/interioristas/preferences/';
  var SUPPORTED=[VERSION,'g314-contact-preferences-2026-10-19-v1'];
  var PREFIX='g314_contact_permission_',NAMES=['id','version','at','source','email','whatsapp','purchase_updates','promotions','proof'];
  var roots=new Set(),ready=false,busy=false,current=null,pending=null,attributes={},offerCode='',passingCheckout=false,error=false,message='';
  var draft={email:false,whatsapp:false,emailValue:'',whatsappValue:'',purchaseUpdates:false,promotions:false};
  var combinedValue='';
  var cartRoot=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
  function query(root,name){return root.querySelector('[data-g314-pref-'+name+']');}
  async function request(url,body){
    var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},12000);
    try{
      var response=await fetch(url,{method:body===undefined?'GET':'POST',credentials:'same-origin',redirect:'error',signal:controller.signal,
        headers:{'Accept':'application/json','Content-Type':'application/json'},body:body===undefined?undefined:JSON.stringify(body)});
      var result=await response.json();
      if(!response.ok)throw new Error(result.error||'No pudimos guardar el cambio. Inténtalo de nuevo.');
      return result;
    }finally{clearTimeout(timer);}
  }
  function notice(text,failed){message=text;error=!!failed;paint();}
  function compactRoot(root){return root.hasAttribute('data-g314-pref-compact')&&!(modal&&modal.classList.contains('g314-contact-welcome--manage'));}
  function combinedContact(value){
    var text=String(value||'').trim();
    if(text.includes('@'))return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text)?{channel:'email',value:text.toLowerCase(),hint:''}:null;
    if(!/^\+?[\d ()-]+$/.test(text))return null;
    var digits=text.replace(/\D/g,'');
    if(!text.startsWith('+')&&/^[2-9]\d{9}$/.test(digits))digits='52'+digits;
    if(/^521\d{10}$/.test(digits))digits='52'+digits.slice(3);
    return /^[1-9]\d{9,14}$/.test(digits)?{channel:'whatsapp',value:'+'+digits,hint:'WhatsApp: +'+digits}:null;
  }
  function applyCombined(value){
    combinedValue=value;var selected=combinedContact(value);
    draft.email=selected?.channel==='email';draft.whatsapp=selected?.channel==='whatsapp';
    draft.emailValue=draft.email?selected.value:'';draft.whatsappValue=draft.whatsapp?selected.value:'';
    return selected;
  }
  function paint(){
    if(modal){var continueButton=modal.querySelector('[data-g314-contact-continue]');if(continueButton){continueButton.setAttribute('data-ready',String(!!current));continueButton.textContent=current?'Seguir comprando':'Ahora no';}}
    roots.forEach(function(root){
      if(!root.isConnected){roots.delete(root);return;}
      var compact=compactRoot(root);
      query(root,'modes').hidden=true;query(root,'channel-controls').hidden=compact;
      query(root,'combined-field').hidden=!compact;
      var combinedInput=query(root,'combined'),selected=combinedContact(combinedValue),hint=query(root,'contact-hint');
      if(combinedInput.value!==combinedValue)combinedInput.value=combinedValue;
      combinedInput.disabled=busy||!compact;hint.hidden=!compact||!selected?.hint;hint.textContent=selected?.hint||'';
      root.setAttribute('data-saved',String(!!(compact&&current&&!pending)));
      ['email','whatsapp'].forEach(function(c){
        var check=root.querySelector('[data-g314-pref-channel="'+c+'"]'),input=root.querySelector('[data-g314-pref-contact="'+c+'"]');
        check.checked=draft[c];check.disabled=busy;
        root.querySelector('[data-g314-pref-field="'+c+'"]').hidden=compact||!draft[c];
        if(input.value!==draft[c+'Value'])input.value=draft[c+'Value'];input.disabled=busy||compact||!draft[c];
      });
      ['purchaseUpdates','promotions'].forEach(function(p){var el=root.querySelector('[data-g314-pref-purpose="'+p+'"]');el.checked=draft[p];el.disabled=busy;});
      query(root,'save').disabled=busy;query(root,'save').textContent=busy?'Guardando…':!ready?'Cargar preferencias':pending?'Volver a intentar':current?'Guardar preferencias':'Activar mi 10%';
      query(root,'withdraw').hidden=!current;query(root,'withdraw').disabled=busy;
      query(root,'status').textContent=message;query(root,'status').setAttribute('data-error',String(error));
      root.setAttribute('aria-busy',String(busy));
    });
  }
  function fromAttributes(attrs){
    if(!SUPPORTED.includes(attrs[PREFIX+'version'])||!attrs[PREFIX+'id']||!/^[a-f0-9]{64}$/.test(attrs[PREFIX+'proof']||''))return null;
    return {id:attrs[PREFIX+'id'],proof:attrs[PREFIX+'proof']};
  }
  function prefill(attrs){
    draft={email:!!attrs[PREFIX+'email'],whatsapp:!!attrs[PREFIX+'whatsapp'],emailValue:attrs[PREFIX+'email']||'',
      whatsappValue:attrs[PREFIX+'whatsapp']?'+'+attrs[PREFIX+'whatsapp']:'',purchaseUpdates:attrs[PREFIX+'purchase_updates']==='true',promotions:attrs[PREFIX+'promotions']==='true'};
    combinedValue=draft.emailValue||draft.whatsappValue;
  }
  function legacyClear(){
    var out={};['order','recovery'].forEach(function(kind){['updates','phone','consent_version','consent_source','consent_at'].forEach(function(part){out['g314_whatsapp_'+kind+'_'+part]=part==='updates'?'false':'';});});return out;
  }
  function codes(cart){
    return (cart.discount_codes||[]).map(function(c){return typeof c==='string'?c:c.code;})
      .concat((cart.cart_level_discount_applications||[]).filter(function(d){return d.type==='discount_code';}).map(function(d){return d.title;}))
      .filter(function(c){return typeof c==='string'&&c.length>0&&c.length<=255;});
  }
  async function updateCart(attrs,withOffer){
    var body={};if(attrs)body.attributes=attrs;
    if(withOffer){var existing=await request(cartRoot+'cart.js');body.discount=Array.from(new Set(codes(existing).concat(offerCode))).join(',');}
    return request(cartRoot+'cart/update.js',body);
  }
  async function bindCart(attrs,withOffer){
    var wanted=Object.assign(legacyClear(),attrs),cart=await updateCart(wanted,withOffer);
    if(!cart.attributes||Object.keys(wanted).some(function(k){return String(cart.attributes[k]||'')!==String(wanted[k]||'');}))throw new Error('La autorización está registrada; falta vincularla al carrito. Pulsa Volver a intentar.');
    attributes=cart.attributes;
    document.dispatchEvent(new CustomEvent('g314:cart-updated',{detail:{cart:cart}}));
  }
  function uuid(){
    if(window.crypto.randomUUID)return window.crypto.randomUUID();
    var bytes=window.crypto.getRandomValues(new Uint8Array(16));bytes[6]=(bytes[6]&15)|64;bytes[8]=(bytes[8]&63)|128;
    return Array.from(bytes,function(b,i){return ([4,6,8,10].indexOf(i)>=0?'-':'')+b.toString(16).padStart(2,'0');}).join('');
  }
  function payload(root){
    if(compactRoot(root)&&!applyCombined(query(root,'combined').value))throw new Error('Escribe un correo o WhatsApp válido.');
    if(!draft.email&&!draft.whatsapp)throw new Error('Elige correo, WhatsApp o ambos.');
    var email=draft.email?draft.emailValue.trim().toLowerCase():'',phone=draft.whatsapp?draft.whatsappValue.trim():'';
    if(draft.email&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))throw new Error('Escribe un correo válido.');
    if(draft.whatsapp&&!/^\+?[1-9][0-9 ()-]{9,28}$/.test(phone))throw new Error('Escribe tu WhatsApp con código de país, por ejemplo +52 55 1234 5678.');
    phone=phone.replace(/[ ()+-]/g,'');
    if(draft.whatsapp&&!/^[1-9][0-9]{9,14}$/.test(phone))throw new Error('Revisa el número de WhatsApp y su código de país.');
    return {version:VERSION,requestId:uuid(),source:root.getAttribute('data-source')||'cart',email:email,whatsapp:phone,
      purchaseUpdates:draft.purchaseUpdates,promotions:draft.promotions,previous:current,website:query(root,'website').value};
  }
  async function save(root){
    if(busy)return;
    if(!ready){await initialize();return;}
    try{if(!pending)pending={body:payload(root)};}
    catch(e){notice(e.message,true);return;}
    busy=true;notice('Estamos guardando tus preferencias.',false);
    try{
      if(!pending.receipt)pending.receipt=await request(BASE+'capture',pending.body);
      if(!pending.receipt.active)throw new Error('Estas autorizaciones se retiraron. Recarga la página para revisar tus preferencias.');
      if(pending.receipt.offer&&pending.receipt.offer.code==='PRIMERA10'&&pending.receipt.offer.percentage===10)offerCode=pending.receipt.offer.code;
      current={id:pending.receipt.id,proof:pending.receipt.proof};
      await bindCart(pending.receipt.attributes,!!offerCode);
      prefill(pending.receipt.attributes);pending=null;
      notice('Tu 10% ya está activado.',false);
    }catch(e){notice(e.message==='Failed to fetch'||e.name==='AbortError'?'No pudimos completar el guardado. Pulsa Volver a intentar.':e.message,true);}
    finally{busy=false;paint();}
  }
  async function withdraw(){
    if(busy||!current)return;
    busy=true;notice('Estamos retirando tus autorizaciones.',false);
    try{
      await request(BASE+'revoke',current);
      var cleared={};NAMES.forEach(function(k){cleared[PREFIX+k]='';});await bindCart(cleared);
      current=null;pending=null;prefill({});notice('Autorizaciones retiradas. Puedes seguir comprando sin recibir estos avisos.',false);
    }catch(e){notice('No pudimos completar el cambio. Vuelve a pulsar Retirar estas autorizaciones.',true);}
    finally{busy=false;paint();}
  }
  function mount(){document.querySelectorAll('[data-g314-preferences]').forEach(function(root){roots.add(root);});paint();}
  var modal=document.querySelector('[data-g314-contact-welcome]'),lastFocus=null;
  function seen(){try{window.sessionStorage.setItem('g314-contact-invite-v1','seen');}catch(e){}}
  function open(){if(!modal)return;lastFocus=document.activeElement;modal.hidden=false;document.body.classList.add('g314-promo-open');modal.querySelector('.g314-first-order-promo__close').focus();}
  function close(){if(!modal)return;seen();modal.hidden=true;document.body.classList.remove('g314-promo-open');if(lastFocus&&lastFocus.focus)lastFocus.focus();}
  async function advanceCheckout(target){
    busy=true;notice('Aplicando tu 10% adicional antes de ir al pago…',false);
    try{
      await updateCart(null,true);busy=false;paint();passingCheckout=true;target.click();passingCheckout=false;
    }catch(e){busy=false;notice('No pudimos aplicar el 10% todavía. Vuelve a pulsar el botón para ir al pago.',true);}
  }
  document.addEventListener('click',function(event){
    var target=event.target.closest('button,a');if(!target)return;
    if(target.hasAttribute('data-g314-pref-save')){event.preventDefault();save(target.closest('[data-g314-preferences]'));}
    if(target.hasAttribute('data-g314-pref-withdraw')){event.preventDefault();withdraw();}
    if(target.hasAttribute('data-g314-contact-close'))close();
    if(target.hasAttribute('data-g314-preferences-open')){if(modal)modal.classList.add('g314-contact-welcome--manage');paint();open();seen();}
    var checkout=target.name==='checkout'||target.getAttribute('href')&&/\/checkout(?:[?#]|$)/.test(target.getAttribute('href'));
    if(checkout&&!passingCheckout&&(busy||offerCode)){
      event.preventDefault();event.stopImmediatePropagation();
      if(busy)notice('Espera a que termine el guardado antes de ir al pago.',false);else advanceCheckout(target);
    }
  },true);
  document.addEventListener('submit',function(event){if(busy&&event.target.matches('form.cart,form[action="/cart"]')){event.preventDefault();event.stopImmediatePropagation();}},true);
  function changed(event){
    var root=event.target.closest('[data-g314-preferences]');if(!root||busy)return;
    if(pending){notice('Termina el guardado con Volver a intentar antes de cambiar la selección.',true);paint();return;}
    var channel=event.target.getAttribute('data-g314-pref-channel'),purpose=event.target.getAttribute('data-g314-pref-purpose'),contact=event.target.getAttribute('data-g314-pref-contact');
    if(event.target.hasAttribute('data-g314-pref-combined'))applyCombined(event.target.value);
    if(channel)draft[channel]=event.target.checked;if(purpose)draft[purpose]=event.target.checked;
    if(contact){draft[contact+'Value']=event.target.value;
      combinedValue=draft.emailValue||draft.whatsappValue;
    }
    pending=null;notice(current?'Guarda tus cambios.':'',false);
  }
  document.addEventListener('change',changed);document.addEventListener('input',function(e){if(e.target.hasAttribute('data-g314-pref-contact')||e.target.hasAttribute('data-g314-pref-combined'))changed(e);});
  document.addEventListener('keydown',function(event){
    if(!modal||modal.hidden)return;if(event.key==='Escape'){close();return;}
    if(event.key==='Tab'){
      var focusables=Array.from(modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')).filter(function(el){return !el.closest('[hidden]')&&el.offsetParent!==null&&el.tabIndex>=0;});
      var first=focusables[0],last=focusables[focusables.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  window.__g314ContactPreferences={mount:mount};
  new MutationObserver(function(records){if(records.some(function(r){return r.addedNodes.length&&Array.from(r.addedNodes).some(function(n){return n.nodeType===1&&(n.matches('[data-g314-preferences]')||n.querySelector('[data-g314-preferences]'));});}))mount();}).observe(document.documentElement,{childList:true,subtree:true});
  mount();
  var loading=null;
  function initialize(){
    if(loading)return loading;
    loading=Promise.all([request(BASE+'status'),request(cartRoot+'cart.js')]).then(async function(results){
      if(results[0].version!==VERSION)throw new Error('Recarga la página para actualizar el formulario.');
      var attrs=results[1].attributes||{},reference=fromAttributes(attrs);
      if(reference){
        var receipt=await request(BASE+'receipt',reference);
        if(receipt.offer&&receipt.offer.code==='PRIMERA10'&&receipt.offer.percentage===10)offerCode=receipt.offer.code;
        if(receipt.active){current=reference;prefill(attrs);message='Tu 10% ya está activado.';}
        else{current=reference;prefill({});message='Hay cambios o bajas en este registro. Puedes retirar las autorizaciones anteriores o guardar una nueva selección.';}
      }
      attributes=attrs;ready=true;error=false;paint();
    }).catch(function(){notice('No pudimos consultar tus preferencias. Pulsa Cargar preferencias para reintentar. Puedes seguir comprando sin cambios.',true);})
      .finally(function(){loading=null;});
    return loading;
  }
  initialize();
  var invited=false;try{invited=window.sessionStorage.getItem('g314-contact-invite-v1')==='seen';}catch(e){}
  if(!invited&&!/\/checkout(\/|$)/.test(window.location.pathname))setTimeout(function(){open();seen();},1200);
})();
